import useSWR, { useSWRConfig } from 'swr';

import apiRequest from '@/services/apiRequest';
import { getSearchApi } from '@/utility/getCoreApi';

interface ISearchRentalsMeta {
  lat: number;
  lng: number;
  city: string;
  state: string;
  country: string;
}
interface ISearchRentals {
  data: unknown[];
  meta: ISearchRentalsMeta;
}
export const useRentalsLocationMeta = () => {
  // TODO: do we still need this? can we use geoip now instead?
  const key = `${getSearchApi()}/rentals`;
  const { cache } = useSWRConfig();
  const optionsToAvoidPolling = {
    revalidateOnMount: !cache.get(key),
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  };
  const fetcher = (url: string) =>
    apiRequest<ISearchRentals>({
      url,
      params: {
        // we only need mata, don't fetch more than 1 rental
        'page[limit]': 1,
        recommended: true,
        remove: 'images',
        mini: 'true',
      },
    }).then(res => {
      return res?.meta;
    });
  return useSWR<ISearchRentalsMeta>(key, fetcher, optionsToAvoidPolling);
};
